import { render, staticRenderFns } from "./SubcontractOrder.vue?vue&type=template&id=5ecba7e0"
import script from "./SubcontractOrder.vue?vue&type=script&lang=js"
export * from "./SubcontractOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports